export enum InformativeCondition {
	LEGAL_NOTICE = "LEGAL_NOTICE",
	PRIVACY_COOKIES = "PRIVACY_COOKIES",
}
